import styled from "styled-components";
import Chip from "../../../components/basics/Chip";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

export const StyledChipForm = styled(Chip)`
  width: 100%;
  font-size: 14px !important;
`;

export const StyledChipTemplates = styled(Chip)`
  width: 100%;
  font-size: 12px !important;
`;

export const IconHelp = styled(HelpOutlineIcon)`
  padding: 20px 0px 0px 2px;
  font-size: 18px;
  font-size: 1.3rem;
`;

export const DivHeandleEmail = styled.div`
  width: 100%;
  .toolbarClassName {
    margin-top: 1vh;
  }
  .editorClassName {
    border: solid lightgray;
    margin-bottom: 1vh;
    min-height: 150px;
  }
`;
